export const headerRouterTable: string[] = ["Número", "Origem", "Status", "Veículo", "Data", "Tempo de trajeto"]

export const mock = [
    {
        number: 12345,
        origin: "Vendas",
        status: "Concluido",
        vehicle: "CMD113",
        date: "23/03/2005",
        track: "2h 34m 54s", 
        freight: [0,1]
        
    },
    {
        number: '12345',
        origin: "Vendas",
        status: "A programar",
        vehicle: "CMD113",
        date: "23/03/2005",
        track: "", 
        freight: [0]
    },
    {
        number: 12345,
        origin: "Vendas",
        status: "A programar",
        vehicle: "CMD113",
        date: "23/03/2005",
        track: "", 
        freight: [2]
    },
    {
        number: 12345,
        origin: "Vendas",
        status: "Concluido",
        vehicle: "CMD113",
        date: "23/03/2005",
        track: "2h 34m 54s", 
        freight: [3]
    },
    
]